import { AxiosResponse } from 'axios';
import axiosInstance from './apiInterceptor';

interface SendOtpPayload {
  phone: string;
}

interface VerifyOtpPayload {
  otp: number;
  phone: string;
}

interface SendOtpResponse {
  statusCode: number;
  status: string;
  message: string;
}

interface LoginPayload {
  otp: number;
  phone: string;
}

interface LoginResponse {
  roleIds: [] | number[]; // Assuming role is an array of numbers
  uarIds: [] | number[];
  accessToken: string;
  userId: number
}
interface SendOtpResponse {
  statusCode: number;
  status: string;
  message: string;
}

interface VerifyOtpResponse {
  statusCode: number;
  status: string;
  message: string;
  data: {
    userId: number;
    phone: string;
    roleIds: number[];
    uarIds:number[];
    accessToken: string;
  };
}

export const login = async (credentials: LoginPayload): Promise<LoginResponse> => {
  try {

    const response: AxiosResponse<LoginResponse> = await axiosInstance.post('/users/login', credentials);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message ?? 'Login failed';
  }
};
// Send OTP
export const sendOTP = async (payload: SendOtpPayload): Promise<SendOtpResponse> => {
  try {
    
    
    const response: AxiosResponse<SendOtpResponse> = await axiosInstance.post(
      'users/send-otp', 
      { 
        phone: payload.phone 
      }
    );
    
    
    return response.data;
  } catch (error: any) {
   
    
    // Handle different error scenarios
    if (error.response) {
      // Server responded with error status
      const errorMessage = error.response.data?.message || 
                          error.response.data?.error || 
                          'Failed to send OTP';
      throw new Error(errorMessage);
    } else if (error.request) {
      // Request was made but no response received
      console.error('No response received:', error.request);
      throw new Error('Network error: Unable to connect to server');
    } else {
      // Something else happened
      console.error('Request setup error:', error.message);
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

// Verify OTP
export const verifyOTP = async (payload: VerifyOtpPayload): Promise<VerifyOtpResponse> => {
  try {
   
    
    const response: AxiosResponse<VerifyOtpResponse> = await axiosInstance.post(
      'users/verify-otp', 
      { 
        phone: payload.phone, 
        otp: payload.otp 
      }
    );
    
   
    
    return response.data;
  } catch (error: any) {
   
    
    // Handle different error scenarios
    if (error.response) {
      // Server responded with error status
      const errorMessage = error.response.data?.message || 
                          error.response.data?.error || 
                          'Invalid OTP';
      throw new Error(errorMessage);
    } else if (error.request) {
      // Request was made but no response received
      console.error('No response received:', error.request);
      throw new Error('Network error: Unable to connect to server');
    } else {
      // Something else happened
      console.error('Request setup error:', error.message);
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};